<template>
  <div class="panel policy_declaration">
    <div class="panel_title">{{ title }}</div>
    <div class="panel_body">
      <ul>
        <template v-for="(item, i) in list">
          <li
            :key="i"
            class="wow animate__animated"
            :class="i < 2 ? 'animate__fadeInLeft' : 'animate__fadeInRight'"
            :style="{ backgroundImage: 'url(' + item.img + ')' }"
            :img="item.img"
          >
            <div>
              <div class="label">{{ item.label }}</div>
              <div class="text clamp_2">{{ item.text }}</div>
              <div class="btn" @click.stop="goPage(item)">查看详情</div>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "policy_declaration",
  data() {
    return {
      title: "政策及申报",
      list: [
        {
          label: "政策信息",
          text: "政策信息是指政府制定和发布的有关政策的信息，包括政策的内容、目的、实施方式、适用范围、时间等方面的信息。帮助公众了解政府的政策方向和政策目标，促进政策的公开透明和民主参与。让公众及时了解政策的内容，提高政策的可行性和执行力。",
          img: require("@/assets/images/home/panel_p_d_01.png"),
          url: "/exhibition-hall/policy-relevant",
          query: { navIndex: 1 },
        },
        {
          label: "政策解读",
          text: "政策解读是指对政府发布的政策进行解释和说明，帮助公众更好地理解政策的内容、目的和实施方式。提高政策的透明度和可理解性，促进公众对政策的参与和反馈。提高政策的可行性和执行力。政策解读也可以为企业、个人等提供指导和参考，帮助他们更好地了解政策的影响和应对措施。",
          img: require("@/assets/images/home/panel_p_d_02.png"),
          url: "/exhibition-hall/policy-relevant",
          query: { navIndex: 2 },
        },
        {
          label: "政策申报",
          text: "政策申报是指企业或组织向政府或相关机构提交申请，以获得政策支持、奖励或认证的过程。申报材料需要符合相关政策和申报要求，避免因不符合条件而被拒绝或被取消认证。申报材料需要真实、准确、全面地反映企业或组织的情况和需求，避免夸大或虚假宣传。政策申报的目的在于促进企业或组织的发展，鼓励创新和转型，提高经济效益和社会贡献。",
          img: require("@/assets/images/home/panel_p_d_03.png"),
          url: "/exhibition-hall/policy-relevant",
        },
        {
          label: "数字化案例申报",
          text: "数字化案例申报是指企业或组织向相关机构提交数字化转型或创新案例的申请和材料，以获得相关政策支持、奖励或认证。数字化案例申报通常需要提供详细的案例描述、数字化技术应用、业务创新、经济效益等方面的信息，以证明数字化转型或创新的成果和价值。目的在于，促进数字化转型和创新的发展，鼓励企业和组织在数字化领域的探索和实践，提高数字化技术的应用水平和经济效益。数字化案例申报也可以为企业和组织提供宣传和推广的机会，增强品牌影响力和市场竞争力。",
          img: require("@/assets/images/home/panel_p_d_04.png"),
          url: "/supply_demand_docking/case-declaration",
        },
      ],
    };
  },
  methods: {
    goPage(tar) {
      if (tar.url) {
        this.$router.push({ path: tar.url, query: tar.query }).catch(error => {});
      } else {
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
